export default {
  FEEDBACK_SEND_REQUEST: "feedback/SEND_REQUEST",
  FEEDBACK_SEND_SUCCESS: "feedback/SEND_SUCCESS",
  FEEDBACK_SEND_FAILURE: "feedback/SEND_FAILURE",
  FEEDBACK_DEFAULT_STATE_SET: "feedback/DEFAULT_STATE_SET"
};
